module.exports = __webpack_public_path__ + "static/08-724314a463808ef2ed020fde09f25db4.jpg";